// This file is maintained for backward compatibility
// Import and re-export the store from the new redux directory
import store from "./redux/store";
export default store;
